import { requests } from './BaseService'
import config from '@/config'

export const LocationService = {
  getById: (locationId: string) =>
    requests().get(`${config.restApiUrl}/locations/${locationId}`),
}
